module.exports = __webpack_public_path__ + "images/bentley_smallb7ff49bd03bcad57bf212ac167a423b6.png";